import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { type PreviewFileMeta } from 'BreetHelpers';

export interface KybAuthState {
	isLoadingKybDetails: boolean;
	previewFile: PreviewFileMeta;
}

const initialState: KybAuthState = {
	isLoadingKybDetails: false,
	previewFile: {
		fileSelectorId: '',
		previewUrl: '',
		type: '',
	},
};

export const kybAuthSlice = createSlice({
	name: 'kybAuth',
	initialState,
	reducers: {
		setPreviewFile: (state, action: PayloadAction<PreviewFileMeta>) => {
			state.previewFile = action.payload;
		},
		setIsLoadingKybDetails: (state, action: PayloadAction<boolean>) => {
			state.isLoadingKybDetails = action.payload;
		},
	},
	selectors: {
		selectIsLoadingKybDetails: (state) => state.isLoadingKybDetails,
		selectPreviewFile: (state) => state.previewFile,
	},
});

export const kybAuthAction = kybAuthSlice.actions;

export default kybAuthSlice.reducer;

export const kybAuthSelectors = kybAuthSlice.selectors;
